import { fetchAgg } from '../../../../common/utils/fetch-agg';

import { getThirdPartyFilterOptionsQuery, GQL_OPERATION_NAME } from './query';

export type ThirdPartyFilterValue = {
	name: string;
	label?: string | null;
};

export type ThirdPartyDynamicFilter = {
	name: string;
	values: ThirdPartyFilterValue[];
};

export type ThirdPartyFilterOptionsPayload = {
	filters: ThirdPartyDynamicFilter[];
};

type ThirdPartyFilterOptionsResponse = {
	search?: {
		configuration?: {
			thirdPartyFilterOptions?: ThirdPartyFilterOptionsPayload | null;
		} | null;
	} | null;
};

type ThirdPartyFilterOptionsVariables = {
	cloudId: string;
	datasourceId: string;
};

export type ThirdPartyFilterOptionsProps = {
	cloudId: string;
	datasourceId: string;
	aggAbsoluteUrl?: string;
};

export const getThirdPartyFilterOptions = async ({
	cloudId,
	datasourceId,
	aggAbsoluteUrl,
}: ThirdPartyFilterOptionsProps): Promise<ThirdPartyFilterOptionsPayload | null> => {
	try {
		const response = await fetchAgg<
			ThirdPartyFilterOptionsVariables,
			ThirdPartyFilterOptionsResponse
		>({
			graphQuery: getThirdPartyFilterOptionsQuery(),
			variables: { cloudId, datasourceId },
			operationName: GQL_OPERATION_NAME,
			aggAbsoluteUrl,
		});

		return response.data?.search?.configuration?.thirdPartyFilterOptions ?? null;
	} catch {
		return null;
	}
};
